





















import { Component, Prop, Vue } from 'vue-property-decorator';
import Routes from '@/util/Routes';
import { getModule } from 'vuex-module-decorators';
import { CmsStore } from '@/stores/cms.store';
import UserStore from '@/stores/user/user.store';
import { BlockDto, RegisterFragmentDto } from '@/api';
import BlocksDispatcher from '@/views/cms/BlocksDispatcher.vue';

@Component({
  components: {BlocksDispatcher},
})
export default class RegisterConfirmation extends Vue {
  private cmsStore = getModule(CmsStore, this.$store);
  private userStore = getModule(UserStore, this.$store);
  private registerFragment: RegisterFragmentDto | null = null;

  @Prop({required: false, default: false})
  public readonly fromCart!: boolean;

  get confirmation(): BlockDto[] | null {
    return this.registerFragment?.confirmation ?? null;
  }

  public async mounted() {
    const cmsFragment = await this.cmsStore.fetchRegisterFragment(this.userStore.currentLanguage);
    if (cmsFragment.success) {
      this.registerFragment = cmsFragment.payload ?? null;
    }
  }

  public async redirectToShop() {
    if (this.fromCart) {
      await this.$router.push({name: Routes.ShoppingCart});
    } else {
      await this.$router.push({name: Routes.Home});
    }
    // force a reload so that cart, etc. is re-fetched. more maintainable than manually updating everything here
    document.location.reload();
  }
}
